import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ActivityDeviationStatus } from '@wilson/interfaces';

@Component({
  selector: 'wilson-activity-card-deviation-content',
  imports: [],
  templateUrl: './activity-card-deviation-content.component.html',
  styleUrls: ['./activity-card-deviation-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCardDeviationContentComponent {
  @Input() activityEndTimeType!: ActivityDeviationStatus;
  @Input() activityEndTimeDifference!: number;
  ActivityDeviationStatus = ActivityDeviationStatus;
}
